import { render, staticRenderFns } from "./setPasswordDialog.vue?vue&type=template&id=1fa794ae&scoped=true"
import script from "./setPasswordDialog.vue?vue&type=script&lang=js"
export * from "./setPasswordDialog.vue?vue&type=script&lang=js"
import style0 from "./setPasswordDialog.vue?vue&type=style&index=0&id=1fa794ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa794ae",
  null
  
)

export default component.exports